const config = {
  // backendUrl: "http://localhost:30001/",
  // backendUrl: "http://localhost:20001/",
  backendUrl: "https://rainbow.saminara.com/",
  PayFren: "https://payfren.id/",
  Resource: "https://resource.saminara.com/",
};
export default config;
